export default "__VITE_ASSET__k5wtlUlk__"